import React, { useState } from "react";
import { useDispatch } from "react-redux";
import {
  closeProductModal,
  refreshProductList,
} from "../../../redux/features/productModalSlice";
import { AddCategory } from "../../../redux/services/categoriesService/categories.Services";
import Swal from "sweetalert2";
import { successToast } from "../../../Utils/toast";
// import { CKEditor } from "@ckeditor/ckeditor5-react";
// import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
function CreateCategory({ refreshData }) {
  const dispatch = useDispatch();
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    status: 1,
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: null,
      }));
    }
  };

//   const handleDescriptionChange = (event, editor) => {
//   const data = editor.getData();
//   setFormData((prev) => ({ ...prev, description: data }));
//   if (errors.description) {
//     setErrors((prev) => ({ ...prev, description: null }));
//   }
// };
// const plainDescription = formData.description.replace(/<[^>]*>/g, "").trim();
// if (!plainDescription) {
//   errors.description = ["Description is required"];
// }
  const validateForm = () => {
    const newErrors = {};
    if (!formData.name.trim()) {
      newErrors.name = ["Category Name is required"];
    }

    setErrors(newErrors);
    return newErrors;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setTimeout(() => {
        const firstErrorField = document.querySelector(".is-invalid");
        if (firstErrorField) {
          firstErrorField.focus();
          firstErrorField.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
      }, 100);
      return;
    }

    try {
      const res = await AddCategory(formData);
      if (res?.success) {
       successToast( res.message);
        refreshData?.();
        dispatch(refreshProductList());
        dispatch(closeProductModal());
      }
    } catch (error) {
      if (error?.response?.status === 422) {
        setErrors(error.response.data.errors || {});
      } else {
        Swal.fire("Error", "Something went wrong", "error");
      }
    }
  };

  return (
    <form onSubmit={handleSubmit}>
       <div className="mb-3">
        <label>Category Name <span className="text-danger">*</span></label>
        <input
          type="text"
          name="name"
          className={`form-control ${errors?.name ? "is-invalid" : ""}`}
          placeholder="Category Name"
          value={formData.name}
          onChange={handleChange}
        />
      </div>
  <div className="mb-3">
  <label>
    Description <span className="text-danger">*</span>
  </label>
  <textarea
    name="description"
    rows="5"
    className={`form-control ${errors?.description ? "is-invalid" : ""}`}
    placeholder="Enter category description..."
    value={formData.description}
    onChange={handleChange}
  />
  {errors?.description && (
    <div className="invalid-feedback d-block">
      {errors.description[0]}
    </div>
  )}
</div>
      <button className="add-btn">
        Create Category
      </button>
    </form>
  );
}

export default CreateCategory;